import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { api } from '../properties/endpoints';

@Injectable({
  providedIn: 'root'
})
export class DigitalSopService {
  constructor(private http: HttpClient) { }

  getSopList() {
    const url = `${api.host}/material/digital-sops`;
    return this.http.get(url);
  }
  searchSopList(value:any) {
    const url = `${api.host}/material/digital-sops/search?q=${value}`;
    return this.http.get(url);
  }
  createSop(payload:any){
    const url = `${api.host}/material/digital-sops`;
    return this.http.put(url,payload);
  }
  getSopById(sopId: string) {
    const url = `${api.host}/material/digital-sops/${sopId}`;
    return this.http.get(url);
  }
  deleteSop(sopId: string){
    const url = `${api.host}/material/digital-sops/${sopId}`;
    return this.http.delete(url,{responseType: 'text'});
  }
  updateSop(payload:any){
    const url = `${api.host}/material/digital-sops`;
    return this.http.post(url,payload);
  }
  updateSteps(payload:any){
    const url = `${api.host}/material/digital-sops/steps`;
    return this.http.post(url,payload);
  }
  updateVideo(payload:any){
    const formData: FormData = new FormData();
    formData.append('file', payload.file);
    formData.append('id', payload.id);
    const url = `${api.host}/material/digital-sops/upload-video`;
    return this.http.post(url, formData, { responseType: 'text' })
  }
  fetchSuggestions(payload:any){
    const url = `${api.host}/ai-assistant/generate-grammar-variations`;
    return this.http.post(url,payload);
  }
  addImage(payload:any){
    const url = `${api.host}/material/digital-sops/${payload.id}/steps/${payload.index}/image`;
    return this.http.post(url,payload.file); 
  }
  getImage(imageUrl:any){
    const url = `${api.host}/material/${imageUrl}`;
    return this.http.get(url,{ responseType: 'blob' });
  }
}